<template>
  <div id="ks8226s">
    <div id="k1">
      <div>
        <label>KS8226S Smart POS</label>
        <label>5200mAh rechargable battery, outstanding bettery life</label>
        <span>
          <!-- <img :src="require('@/assets/pic/ks8226s/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/ks8226s/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <img :src="require('@/assets/pic/ks8226s/icongp.png')"/>
    </div>
    <div id="k3">
      <div>Compact design, easy operation</div>
      <div>Ergonomics design, slim & practical.</div>
    </div>
    <div id="k4">
      <div>Multiple and stable comminucations</div>
      <div>2G/3G/4G, WiFi, Bluetooth</div>
    </div>

    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      asdata: [],
      spdata: {
        file: 'ks8226s',
        data: [
          {label: 'Processor', desc: ['Quad-Core@1.1GHz)'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['1GB RAM+8GB ROM', '2GB RAM+16GB ROM (optional) ', 'MicroSDx1 support up to 32GB'],pic: 'ram.png'},
          {label: 'OS', desc: ['ZOS based on Android 7.1'], pic: 'sys.png'},
          {label: 'Algorithm', desc: ['3DES、AES、RSA、SHA-256、RSA、SM2、SM3、SM4、etc.'], pic: 'safe.png'},
          {label: 'Display', desc: ['5” 720x1280', 'Backlight control', 'Multi-touch operation'], pic: 'disp.png'},
          {label: 'NFC(optional)', desc: ['13.56M  RFID'], pic: 'nfc.png'},
          {label: 'Printer', desc: ['Built-in 58mm thermal printer', '40mm paper roll'], pic: 'prt.png'},
          {label: 'Camera', desc: ['Rear: 5 mega pixels, flash, auto focus', 'Front: 2 mega pixels', 'Support 1D/2D'], pic: 'face.png'},
          {label: 'Cellular Network', desc: ['Dual sim slot (optional) ', ' GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11 a / b / g / n', '2.4G Hz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.0 and above', 'BLE'], pic: 'blt.png'},
          {label: 'Location ', desc: ['Built-in GPS/Beidou/Glonass', 'LBS', 'AGPS'], pic: 'lbs.png'},
          {label: 'Biometric (optional)', desc: ['Fingerprint', 'Iris'], pic: 'act.png'},
          {label: 'Speaker', desc: ['Built-in speaker, 0.5 W', '82dB±3dB '], pic: 'speaker.png'},
          {label: 'Port', desc: ['USB Type-C x 1'], pic: 'port.png'},
          {label: 'Keypad', desc: ['Virtual pinpad'], pic: 'keyb.png'},
          {label: 'Button', desc: ['Power x1', 'Volume x2'], pic: 'keyt.png'},
          {label: 'Battery', desc: ['LiPo battery, 3.7V/5200mAh', 'Optional wide temperature battery'], pic: 'battery.png'},
          {label: 'Adapter', desc: ['Input: AC 100-240V', 'Output: DC 5V/2A'], pic: 'char.png'},
          {label: 'Dimension(L×W×H）', desc: ['190mm×82mm×59mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Working temp: 0℃~+50℃', 'Storage temp: -20℃~+70℃', 'Relative humidity: 10%~90%RH(non-condensing)'], pic: 'env.png'}

        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ks8226s {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8226s/1.png');
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: .4rem;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 2.45rem;
  margin-left: 3.62rem;
  /* width: 4.138rem; */
  
}
#k1 label {
  display: block;
  font-size: .55rem;
  font-weight: bold;
  color: white;
}
#k1 label:nth-child(2) {
  width: 5.27rem;
  white-space: normal;
  font-size: .36rem !important;
  font-weight: 500 !important;
  /* color: #313333 !important; */
  margin-top: .2rem;
  color: #FFFFFF;
}


#k2 {
  background: #EEEEEE  ;
  text-align: center;
  height: 1.78rem;
  overflow: hidden;
  box-sizing: border-box;
  /* line-height: 1.78rem !important; */
}

#k2 img {
  margin: .27rem auto;
  /* height: 1.24rem; */
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8226s/3.png');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.5rem;
}
#k3 div:nth-child(1) {
  margin-top: 3.18rem;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
  width: 4.97rem;
}
#k3 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  margin-top: .1rem;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8226s/4.png');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  text-align: center;
}
#k4 div:nth-child(1) {
  font-weight: bold;
  margin: 1.58rem auto 0 auto;
  font-size: .6rem;
  font-weight: bold;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  width: 6.2rem;
  color: #F4F4F4;
  margin: .4rem auto;
}



</style>
